import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const customRegex =
  (
    regex: RegExp,
    options?: { failOnMatch?: boolean; errorName?: string; pretraitement?: (value: string) => string }
  ): ValidatorFn =>
  (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }
    let value = control.value;
    if (typeof options?.pretraitement === 'function') {
      value = options.pretraitement(value);
    }
    const concorde = regex.test(value);
    const doitEchouerSurConcordance = options?.failOnMatch || false;
    const nomFlagErreur = options?.errorName || 'customRegex';
    const erreur = { [nomFlagErreur]: true };

    if (concorde) {
      if (doitEchouerSurConcordance) {
        return erreur;
      }
      return null;
    }
    if (doitEchouerSurConcordance) {
      return null;
    }
    return erreur;
  };
